import { DatePipe } from '@angular/common';
import { CommonDataPipe } from '../_infrastructure/CommonData/CommonDataPipe';
import { isNullOrUndefined } from '../_infrastructure/objectUtils';
import { Directive, Input, HostListener, OnInit } from '@angular/core';
import { delay } from 'rxjs/operators';

export default class DateHelpers {
  static getMaximumDate(): Date {
    let data = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0);
    return data;
  }
  static getMinimumDate(): Date {
    return new Date(1900,0,1,0,0,0,0);
  }


  public static isDatesAdjacent(firstDate: Date, secondDate: Date): boolean {
    var dayBefore = this.addDays(firstDate, -1);
    var dayAfter = this.addDays(firstDate, 1);

    return this.isSameDay(dayBefore, secondDate) || this.isSameDay(dayAfter, secondDate);
  }
  public static  isSameDay(firstDate: Date, secondDate: Date): boolean {
    return firstDate.getFullYear() == secondDate.getFullYear() &&
      firstDate.getMonth() == secondDate.getMonth() &&
      firstDate.getDate() == secondDate.getDate();
  }
  public static addDays(date: Date, numberOfDays: number): Date {
    var newDate = new Date(date);
    newDate.setDate(date.getDate() + numberOfDays);
    return newDate;
  }

  public static truncateDate(date: Date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  public static calculateAge(birthday:Date) { // birthday is a date
  var ageDifMs = Date.now() - birthday.getTime();
  var ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  public static isAdult(dateOfBirth: Date) {
    const isAdult = DateHelpers.calculateAge(dateOfBirth) >= 18;
    return isAdult;
  }

  public static logDates(item: any) {
    console.log(`Start : ${item.startDate}  EndDate ${item.endDate}`);
  }

  //Correção para os input datepickers que criam objectos Date com GMT
  //public static dateFix(d: Date) {
  //  if (d == undefined ) {
  //    return null;
  //  } else {
  //    var timeZoneDifference = d.getTimezoneOffset()
  //    d.setTime(d.getTime() + timeZoneDifference * 60 * 1000);
  //    return d;
  //  }
  //}

  public static dateFix(d: Date) {
    if (d == undefined) {
      return null;
    } else {
      let offSet = (d.getTimezoneOffset() /60);

      let newStringDate;
      if (offSet >= 0) {
        newStringDate = d.getUTCFullYear().toString() + '/' + (d.getUTCMonth() + 1).toString() + '/' + d.getUTCDate().toString();
        let result = new Date(newStringDate);

        return result;
      } else {
        return d;
      }
    }
  }

  public static getDateText(date: Date, datePipe: DatePipe) {
    if (isNullOrUndefined(date) || date.toString() === "")
      return "";
    else
      return datePipe.transform(date, 'yyyy-MM-dd');
  }

  public static formatDateGeneral(event: any) {

    if (event.code != "ArrowLeft" && event.code != "ArrowRight") {
      var position = Number(event.target.selectionStart);
      let value = event.target.value.replace(/\D/g, '');
      //let specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft', 'Delete', 'Control', 'Shift', 'Alt'];
      let specialKeys: Array<string> = ['Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft', 'Control', 'Shift', 'Alt'];
      var addPosition;

      if (specialKeys.indexOf(event.key) == -1) {

        //PIT30571 - Se existir texto seleccionado o mesmo deve ser substituido pela key que foi pressionada
        if (window.getSelection().toString().length > 0) {
          let value = event.target.value.substr(0, event.target.selectionStart) + event.key + event.target.value.substr(event.target.selectionEnd, 20);
          event.target.value = value;
        }
        
        const date = [];

        value.split('').forEach((char, index) => {
          switch (index) {
            case 4:
            case 6:
              date.push('-');
              //if (event.target.value.length < 9 && event.key != "Backspace" && (position == 5 || position == 8)) {
              if (value.length < 9 && event.key != "Backspace" && (position == 5 || position == 8)) {
                addPosition = true;
              }
              break;
          }
          date.push(char);
        })

        if (addPosition) {
          position++;
        }
        
        event.target.value = date.join('');
        event.target.setSelectionRange(position, position);
      }
    }
  }


  public static onlyNumbers(event: any) {
    let regex: RegExp = new RegExp(/^[0-9]/g);
    let specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft', 'Delete', 'Control', 'Shift', 'Alt'];

    //Impedir que ao Tab sai do campo até a data estar completa
    //Para evitar data automática, se o campo apenas tiver 2024 ao pressionar Tab, gera automáticamente a data 2024-01-01
    if (event.key == 'Tab' && event.target.value.length < 8) {
      event.preventDefault();
      return false;
    }

    if (specialKeys.indexOf(event.key) !== -1) {
      return;
    } else {
      if (regex.test(event.key)) {
        if (window.getSelection().toString().length <= 0) {//PIT30571 - Apenas efetuar o formate se não existir texto seleccionado no campo de data
          //PIT30571 - Correcção da posição do cursor quando a data é digitada muito rápido: Start
          this.formatDateGeneral(event);
          //PIT30571 - Correcção da posição do cursor quando a data é digitada muito rápido: End
        }
        
        return true;
      } else {
        if (!event.ctrlKey) {
          event.preventDefault();
          return false;
        }
      }
    }
  }

  public static onDateChange(event: any, dp: any, objectDate: any/*, minDate: any, maxDate: any*/) {
    let value = event.target.value;
    
    if (value != objectDate && (value == new Date(dp.minDate).toISOString().split('T')[0] || value == new Date(dp.maxDate).toISOString().split('T')[0])) {
      event.target.value = "";
      dp._bsValue = null;
    }
  }

}
